var map = {
	"./book/general.html": 3,
	"./connect.html": 4,
	"./credit.html": 5,
	"./dashboard.html": 6,
	"./dialogs/book.html": 7,
	"./dialogs/edit-profile.html": 8,
	"./dialogs/image.html": 9,
	"./dialogs/likes.html": 10,
	"./dialogs/links.html": 11,
	"./dialogs/mailing-list.html": 12,
	"./dialogs/profile.html": 13,
	"./dialogs/support.html": 14,
	"./dialogs/thumbnail.html": 15,
	"./dialogs/tutorial.html": 16,
	"./discussion.html": 17,
	"./editing_list.html": 18,
	"./entries.html": 19,
	"./fav_list.html": 20,
	"./forum.html": 21,
	"./guideline.html": 22,
	"./home.html": 23,
	"./home_alt.html": 24,
	"./introduction.html": 25,
	"./kula/char.html": 26,
	"./kula/learn.html": 27,
	"./kula/lesson.html": 28,
	"./kula/message-toast.html": 29,
	"./kula/quiz_dialog.html": 30,
	"./kula/start_quiz_dialog.html": 31,
	"./news.html": 32,
	"./partial/action-bottom-sheet.html": 33,
	"./partial/anction-bottom-sheet.html": 34,
	"./partial/comment.html": 35,
	"./partial/discussion_comment.html": 36,
	"./partial/entry_card.html": 37,
	"./partial/fav-list.html": 38,
	"./partial/forum.html": 39,
	"./partial/header.html": 40,
	"./partial/history.html": 41,
	"./partial/panel-notification-en.html": 42,
	"./partial/panel-notification.html": 43,
	"./partial/post-digest.html": 44,
	"./partial/post.html": 45,
	"./partial/quake.html": 46,
	"./partial/sidenav.html": 47,
	"./partial/timeline_event.html": 48,
	"./partial/timeline_event_en.html": 49,
	"./partial/user-menu-buttons.html": 50,
	"./partial/user_status.html": 51,
	"./personal.html": 52,
	"./post-single.html": 53,
	"./quakes.html": 54,
	"./sign_in.html": 1,
	"./timeline.html": 55,
	"./transcription.html": 56,
	"./transcription/action_buttons.html": 57,
	"./transcription/confirm_dialog.html": 58,
	"./transcription/content.html": 59,
	"./transcription/content_status.html": 60,
	"./transcription/diff_dialog.html": 61,
	"./transcription/finishing_dialog.html": 62,
	"./transcription/history.html": 63,
	"./transcription/input.html": 64,
	"./transcription/legends.html": 65,
	"./transcription/message-toast.html": 66,
	"./transcription/notes.html": 67,
	"./transcription/starting_dialog.html": 68,
	"./transcription/view.html": 69
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	return map[req] || (function() { throw new Error("Cannot find module '" + req + "'.") }());
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2;



//////////////////
// WEBPACK FOOTER
// ./app/templates \.html$
// module id = 2
// module chunks = 0